import { Component, Input } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
//
@Component({
  templateUrl: './park-tasks.html',
  selector: 'park-tasks'
})
export class ParkTasksComponent {
  @Input() tasks: {};
  @Input() completedTasks: {};
  @Input() parkId: any;
  @Input() id: any;
  objectKeys = Object.keys;

  constructor (public ngxSmartModalService: NgxSmartModalService) {

  }

  public filters: [{ value: string, label: string }] = [
    {value: 'Complete', label: 'Complete'},
    {value: 'Due/Planned', label: 'Due/Planned'},
    {value: 'All', label: 'All'},
  ];

  public selectedFilter: string = null;

  public filteredTasks() {
    const filteredTasks = {};

    if (this.selectedFilter === null || this.selectedFilter === 'All' || this.selectedFilter === 'Due/Planned') {
      Object.keys(this.tasks).forEach(idx => {
        filteredTasks[idx] = {
          title: this.tasks[idx].title,
          dueDate: this.tasks[idx].dueDate,
          description: this.tasks[idx].description,
          priority: this.tasks[idx].priority,
          status: 'due'
        };
      });
    }

    if (this.selectedFilter === null || this.selectedFilter === 'All' || this.selectedFilter === 'Complete') {
      Object.keys(this.completedTasks).forEach(idx => {
        filteredTasks[idx] = {
          title: this.completedTasks[idx].title,
          dueDate: this.completedTasks[idx].date,
          description: this.completedTasks[idx].description,
          status: 'complete'
        };
      });
    }

    return filteredTasks;
  }

  public setFilter($event: any) {
    this.selectedFilter = $event.target.value;
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/tasks/park-tasks.component.ts